import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UserContext } from '@core/models';
import { UserContextService } from '@core/services';
import { BtnType, Icon } from '@shared/enums';
import { take } from 'rxjs';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';
import { clientClassObj } from '@shared/utils';

const leftIcons = [
  Icon.ArrowLeft,
  Icon.ChevronLeft,
  Icon.Danger,
  Icon.FileDownload,
  Icon.Plus,
  Icon.Sync,
];

@Component({
  selector: 'sp-button',
  template: `
    <button [ngClass]="btnClasses" [disabled]="disabled" [type]="type">
      <i
        *ngIf="iconPosition === 'left'"
        [ngClass]="icon"
        aria-hidden="true"
        [ngStyle]="{ color: iconColor }"></i>
      <ng-content></ng-content>
      <i *ngIf="iconPosition === 'right'" [ngClass]="icon" aria-hidden="true"></i>
    </button>
  `,
  styleUrls: ['button.component.scss'],
})
export class ButtonComponent implements OnInit {
  // Button attribute and class inputs
  @Input() btn: BtnType;
  @Input() btnSize: string;
  @Input() type = 'button';
  @Input() disabled = false;
  @Input() extraClasses: string;
  @Input() icon: Icon;
  @Input() isCircled = false;

  /** ngClass map for button */
  btnClasses: { [key: string]: boolean };
  buttonColor: string;
  iconColor: string;
  textColor = 'white';
  enableHover = false;
  /** Position of icon is left, right, or none (no icon) */
  iconPosition: 'left' | 'right' | 'none' = 'none';

  // constructor(private session: SessionService) {}

  /* eslint-disable  @angular-eslint/no-output-on-prefix */
  @Output() onClick = new EventEmitter();

  @HostListener('click', ['$event']) clicked($event: Event): void {
    if (!this.disabled) {
      this.onClick.emit($event);
    }
  }

  constructor(private userContextService: UserContextService) {}

  ngOnInit(): void {
    this.userContextService.userContext$.pipe(take(1)).subscribe((res: UserContext) => {
      const programCode = res.programCode.toLowerCase();
      const enableHover = ProgramCodeConstants.isSureClient(programCode);

      this.btnClasses = ['btn', `btn-${this.btn}`]
        .concat(this.extraClasses?.split(/\s+/))
        .concat(enableHover ? 'btn-hoverable' : null)
        .filter(x => x?.length > 0)
        .reduce((acc, className) => ((acc[className] = true), acc), <{ [key: string]: boolean }>{});
      this.btnClasses = Object.assign(this.btnClasses, {
        isCircled: this.isCircled,
        ...clientClassObj(programCode),
      });

      this.iconPosition = this.icon ? (leftIcons.includes(this.icon) ? 'left' : 'right') : 'none';
    });
  }

  //TODO this will be used for program codes
  // private getProgramCode(): string {
  //   // Works because spProgram$ is always defined synchronously
  //   let programCode: string;
  //   this.session.spProgram$.pipe(take(1)).subscribe(program => {
  //     programCode = (program && program.programCode) || WellKnownProgramCodes.Sure;
  //   });
  //   return programCode;
  // }
}
